<template>
  <div
    v-if="visible"
    class="modal fade show d-block"
    id="gestionNovedadesModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="gestionNovedadesModalLabel"
    aria-hidden="false"
    style="background-color: rgba(0,0,0,0.5);"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div
        class="card shadow-lg border-0"
        style="border-radius: 15px; overflow: hidden;"
      >
        <!-- Header del Modal -->
        <div
          class="card-header bg-gradient-primary text-white d-flex justify-content-between align-items-center py-3 position-relative"
        >
          <div class="d-flex align-items-center">
            <div class="bg-white bg-opacity-20 rounded-circle p-2 me-1">
              <i class="fas fa-clipboard-check"></i>
            </div>
            <div>
              <h5 class="mb-0 fw-bold">Gestión de Novedades</h5>
              <small class="opacity-75"
                >Seguimiento y gestión de incidentes</small
              >
            </div>
          </div>
          <div class="d-flex align-items-center coordenadas-container">
            <div class="coordenada-item">
              <div class="coordenada-label">
                <i class="fas fa-map-marker-alt me-1"></i>
                LATITUD
              </div>
              <div class="coordenada-valor">{{ novedad.latitud || "N/A" }}</div>
            </div>
            <div class="coordenada-separador">|</div>
            <div class="coordenada-item">
              <div class="coordenada-label">
                <i class="fas fa-map-marker-alt me-1"></i>
                LONGITUD
              </div>
              <div class="coordenada-valor">
                {{ novedad.longitud || "N/A" }}
              </div>
            </div>
          </div>
          <!-- Botón de cerrar pegado al lado derecho -->
          <button
            type="button"
            class="btn btn-outline-light btn-sm rounded-circle cerrar-btn position-absolute"
            @click="cerrarModal"
            title="Cerrar modal"
            style="right: 15px; top: 50%; transform: translateY(-50%); animation: none; transition: none;"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Body del Modal -->
        <div class="card-body p-0">
          <div class="row g-0 h-100">
            <!-- Panel Izquierdo - Formulario -->
            <div class="col-12 col-lg-6">
              <div class="p-4 h-100">
                <!-- Tabs -->
                <ul class="nav nav-tabs mb-4" id="gestionTabs" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      :class="{ active: tabActiva === 'crear' }"
                      id="crear-tab"
                      href="#"
                      role="tab"
                      @click.prevent="tabActiva = 'crear'"
                    >
                      <i class="fas fa-plus-circle me-2"></i>Crear
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      :class="{ active: tabActiva === 'detalles' }"
                      id="detalles-tab"
                      href="#"
                      role="tab"
                      @click.prevent="tabActiva = 'detalles'"
                    >
                      <i class="fas fa-info-circle me-2"></i>Detalles
                    </a>
                  </li>
                </ul>

                <!-- Contenido de Tabs -->
                <div class="tab-content" id="gestionTabsContent">
                  <!-- Tab Crear -->
                  <div
                    class="tab-pane fade"
                    :class="{ 'show active': tabActiva === 'crear' }"
                    id="crear"
                    role="tabpanel"
                    v-show="tabActiva === 'crear'"
                  >
                    

                    <form @submit.prevent="guardarNovedad">
                      <!-- Indicador de Tipo -->
                      <div class="row mb-3">
                        <div class="col-12">
                          <div class="alert alert-info d-flex align-items-center" role="alert">
                            <i class="fas fa-info-circle me-2"></i>
                            <div>
                              <strong>Tipo de Seguimiento:</strong> 
                              <span v-if="novedad.viaje_id" class="badge bg-primary ms-2">
                                <i class="fas fa-truck me-1"></i>Viaje ID: {{ novedad.viaje_id }}
                              </span>
                              <span v-else-if="novedad.det_postulacion_id" class="badge bg-warning ms-2">
                                <i class="fas fa-file-alt me-1"></i>Postulación ID: {{ novedad.det_postulacion_id }}
                              </span>
                              <span v-else class="badge bg-secondary ms-2">
                                <i class="fas fa-question-circle me-1"></i>Tipo no identificado
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Información del Vehículo -->
                      <div class="row">
                        <div class="col-md-4 mb-3">
                          <label class="form-label fw-bold">
                            <i class="fas fa-building text-info me-2"></i
                            >Vehiculo
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            :value="getPlacaVehiculo(novedad) || 'N/A'"
                            placeholder="Vehiculo asignado..."
                            readonly
                            disabled
                          />
                        </div>
                        <div class="col-md-4 mb-3">
                          <label class="form-label fw-bold">
                            <i class="fas fa-building text-info me-2"></i
                            >Remolque
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            :value="getRemolque(novedad) || 'N/A'"
                            placeholder="Remolque asignado..."
                            readonly
                            disabled
                          />
                        </div>
                        <div class="col-md-4 mb-3">
                          <label class="form-label fw-bold">
                            <i class="fas fa-building text-info me-2"></i
                            >Empresa
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            :value="getEmpresa(novedad) || 'N/A'"
                            placeholder="Empresa del viaje..."
                            readonly
                            disabled
                          />
                        </div>
                      </div>

                      <!-- Información del Viaje -->
                      <div class="row">
                        <div class="col-md-4 mb-3">
                          <label class="form-label fw-bold">
                            <i class="fas fa-user text-primary me-2"></i
                            >Conductor
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            :value="getConductor(novedad) || 'N/A'"
                            placeholder="Conductor asignado..."
                            readonly
                            disabled
                          />
                        </div>

                        <div class="col-md-4 mb-3">
                          <label class="form-label fw-bold">
                            <i class="fas fa-phone text-success me-2"></i
                            >Celular
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            :value="getConductorCelular(novedad) || 'N/A'"
                            placeholder="Número de celular del conductor..."
                            readonly
                            disabled
                          />
                        </div>

                        <div class="col-md-4 mb-3">
                          <label class="form-label fw-bold">
                            <i class="fas fa-id-card text-warning me-2"></i
                            >Cédula
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            :value="getConductorDocumento(novedad) || 'N/A'"
                            placeholder="Número de cédula del conductor..."
                            readonly
                            disabled
                          />
                        </div>
                      </div>

                      <!-- Dirección -->
                      <div class="mb-3">
                        <label class="form-label fw-bold">
                          <i class="fas fa-map-marker-alt text-danger me-2"></i
                          >Dirección
                        </label>
                        <div class="input-group">
                           <input
                             type="text"
                             class="form-control"
                             :class="{ 'is-invalid': errores.direccion }"
                             v-model="formulario.direccion"
                             @input="limpiarErrores"
                             placeholder="Ingrese la dirección del incidente..."
                           />
                          <span
                            class="input-group-text bg-danger text-white"
                            v-if="errores.direccion"
                          >
                            <i class="fas fa-exclamation-circle"></i>
                          </span>
                        </div>
                        <div class="invalid-feedback" v-if="errores.direccion">
                          {{ errores.direccion }}
                        </div>
                      </div>

                      <!-- Fecha y Hora Reporte -->
                      <div class="row g-3 mb-3">
                        <div class="row g-3 mb-3">
                          <div class="col-3">
                            <label class="form-label fw-bold">
                              <i
                                class="fas fa-map-marker-alt text-info me-2"
                              ></i
                              >Latitud
                            </label>
                            <input
                              type="text"
                              class="form-control bg-light"
                              v-model="formulario.latitud"
                              readonly
                              disabled
                            />
                          </div>
                          <div class="col-3">
                            <label class="form-label fw-bold">
                              <i
                                class="fas fa-map-marker-alt text-info me-2"
                              ></i
                              >Longitud
                            </label>
                            <input
                              type="text"
                              class="form-control bg-light"
                              v-model="formulario.longitud"
                              readonly
                              disabled
                            />
                          </div>
                          <div class="col-md-3 mb-3">
                            <label class="form-label fw-bold">
                              <i
                                class="fas fa-exclamation-triangle text-warning me-2"
                              ></i
                              >Novedad
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="formulario.novedad"
                              placeholder="Tipo de novedad..."
                              readonly
                              disabled
                            />
                          </div>

                          <div class="col-md-3 mb-3">
                            <label class="form-label fw-bold">
                              <i
                                class="fas fa-exclamation-triangle text-warning me-2"
                              ></i
                              >Sub Novedad
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="novedad.nSubNovedadGps"
                              placeholder="Tipo de novedad..."
                              readonly
                              disabled
                            />
                          </div>
                        </div>
                      </div>

                      <!-- Botón para establecer fecha y hora actual -->
                      <div class="row mb-3">
                        <div class="col-12">
                          <button
                            type="button"
                            class="btn btn-outline-info btn-sm"
                            @click="establecerFechaHoraActual"
                          >
                            <i class="fas fa-sync-alt me-2"></i>
                            Usar fecha y hora actual
                          </button>
                        </div>
                      </div>

                      <!-- Coordenadas -->

                      <div class="row">
                           <div class="col-3">
                             <label class="form-label fw-bold">
                               <i class="fas fa-calendar text-success me-2"></i
                               >Fecha Reporte
                             </label>
                             <div class="input-group">
                               <input
                                 type="date"
                                 class="form-control"
                                 :class="{ 'is-invalid': errores.fecha_reporte }"
                                 v-model="formulario.fecha_reporte"
                                 @input="limpiarErrores"
                               />
                               
                            <span
                              class="input-group-text bg-success text-white"
                            >
                              <i class="fas fa-calendar"></i>
                            </span>
                          
                           </div>
                           <div class="invalid-feedback" v-if="errores.fecha_reporte">
                             {{ errores.fecha_reporte }}
                           </div>
                         </div>
                         <div class="col-3">
                           <label class="form-label fw-bold">
                             <i class="fas fa-clock text-warning me-2"></i>Hora
                             Reporte
                           </label>
                          <div class="input-group">
                            <input
                              type="time"
                              class="form-control"
                              :class="{ 'is-invalid': errores.hora_reporte }"
                              v-model="formulario.hora_reporte"
                              @input="limpiarErrores"
                            />
                            
                           
                            <span
                              class="input-group-text bg-success text-white"
                            >
                              <i class="fas fa-check"></i>
                            </span>
                          </div>
                          <div class="invalid-feedback" v-if="errores.hora_reporte">
                            {{ errores.hora_reporte }}
                          </div>
                        </div>
                        <!-- Estado -->
                         <div class="col-md-3 mb-3">
                           <label class="form-label fw-bold">
                             <i class="fas fa-flag text-primary me-2"></i>Novedad En Ruta
                           </label>
                           <select
                             class="form-control"
                             :class="{ 'is-invalid': errores.novedad_reporte }"
                             v-model="formulario.novedad_reporte"
                             @change="limpiarErrores"
                           >
                             <option value="">Seleccionar novedad...</option>
                             <option
                               v-for="novedad in novedadesEnRuta"
                               :key="novedad.id"
                               :value="novedad.nombre"
                             >
                               {{ novedad.nombre }}
                             </option>
                           </select>
                           <div class="invalid-feedback" v-if="errores.novedad_reporte">
                             {{ errores.novedad_reporte }}
                           </div>
                         </div>
                        <div class="col-md-3 mb-3">
                          <label class="form-label fw-bold">
                            <i class="fas fa-flag text-success me-2"></i>Estado
                          </label>
                          <input
                            type="text"
                            class="form-control bg-success text-white"
                            value="Gestionado"
                            readonly
                            disabled
                          />
                        
                        </div>
                      </div>

                      <!-- Observaciones -->
                      <div class="mb-4">
                        <label class="form-label fw-bold">
                          <i class="fas fa-comment-alt text-secondary me-2"></i
                          >Observaciones
                        </label>
                        <textarea
                          class="form-control"
                          rows="4"
                          v-model="formulario.observaciones"
                          placeholder="Ingrese observaciones adicionales..."
                        ></textarea>
                      </div>

                      <!-- Botones de Acción -->
                      <div class="d-flex gap-2">
                         <button
                           type="submit"
                           class="btn px-4"
                           :class="puedeGuardar ? 'btn-primary' : 'btn-secondary'"
                           :disabled="guardando || !puedeGuardar"
                           :title="!puedeGuardar ? 'Complete todos los campos obligatorios para guardar' : 'Guardar novedad'"
                         >
                          <i
                            class="fas me-2"
                            :class="
                              guardando ? 'fa-spinner fa-spin' : 'fa-save'
                            "
                          ></i>
                           {{ guardando ? "Guardando..." : (!puedeGuardar ? "Complete los campos" : "Guardar") }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-secondary px-4"
                          @click="limpiarFormulario"
                        >
                          <i class="fas fa-eraser me-2"></i>
                          Limpiar
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-danger px-4"
                          @click="cerrarModal"
                        >
                          <i class="fas fa-times me-2"></i>
                          Cancelar
                        </button>
                      </div>
                    </form>
                  </div>

                  <!-- Tab Detalles -->
                  <div
                    class="tab-pane fade"
                    :class="{ 'show active': tabActiva === 'detalles' }"
                    id="detalles"
                    role="tabpanel"
                    v-show="tabActiva === 'detalles'"
                  ></div>
                </div>
              </div>
            </div>

            <!-- Panel Derecho - Mapa (solo en pestaña Crear) -->
            <div class="col-12 col-lg-6" v-if="tabActiva === 'crear'">
              <div class="mapa-container h-100">
                <!-- Contenido del Mapa -->
                <div class="tab-content h-100" id="mapaTabsContent">
                  <div
                    class="tab-pane fade show active h-100"
                    id="mapa"
                    role="tabpanel"
                  >
                    <div class="mapa-content">
                      <gmap-map
                        :center="mapCenter"
                        :zoom="mapZoom"
                        style="width: 100%; height: 100%;"
                        @click="onMapClick"
                      >
                        <gmap-marker
                          :position="markerPosition"
                          :icon="markerIcon"
                          @click="onMarkerClick"
                        ></gmap-marker>
                      </gmap-map>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade h-100"
                    id="satelite"
                    role="tabpanel"
                  >
                    <div class="mapa-content">
                      <gmap-map
                        :center="mapCenter"
                        :zoom="mapZoom"
                        :map-type-id="'satellite'"
                        style="width: 100%; height: 100%;"
                        @click="onMapClick"
                      >
                        <gmap-marker
                          :position="markerPosition"
                          :icon="markerIcon"
                          @click="onMarkerClick"
                        ></gmap-marker>
                      </gmap-map>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Panel Derecho - Tabla Expandida (solo en pestaña Detalles) -->
            <div class="col-12" v-if="tabActiva === 'detalles'">
              <div class="p-4 h-100">
                <h6 class="fw-bold mb-3">
                  <i class="fas fa-list text-primary me-2"></i>Historial de
                  Gestiones
                </h6>
                <div class="table-responsive h-100">
                  <table class="table table-striped table-hover">
                    <thead class="table-dark">
                      <tr>
                        <th><i class="fas fa-cog me-2"></i>Acción</th>
                        <th><i class="fas fa-building me-2"></i>Empresa</th>
                        <th><i class="fas fa-building me-2"></i>Vehiculo</th>
                        <th><i class="fas fa-user me-2"></i>Conductor</th>
                        <th>
                          <i class="fas fa-exclamation-triangle me-2"></i
                          >Subnovedad
                        </th>
                        <th><i class="fas fa-calendar me-2"></i>Fecha</th>
                        <th><i class="fas fa-clock me-2"></i>Hora</th>
                        <th><i class="fas fa-flag me-2"></i>Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span class="badge bg-primary">
                            <i class="fas fa-plus me-1"></i>Pendiente
                          </span>
                        </td>
                        <td>
                          <i class="fas fa-building text-info me-2"></i>
                          {{ getEmpresa(novedad) || "N/A" }}
                        </td>
                        <td>
                          <i class="fas fa-truck text-warning me-2"></i>
                          {{ getPlacaVehiculo(novedad) || "N/A" }}
                        </td>
                        <td>
                          <i class="fas fa-user-circle text-primary me-2"></i>
                          {{ getConductor(novedad) || "N/A" }}
                        </td>
                        <td>
                          <i class="fas fa-exclamation-triangle text-warning me-2"></i>
                          {{ getSubnovedad(novedad) || "N/A" }}
                        </td>
                        <td>
                          <i class="fas fa-calendar text-success me-2"></i>
                          {{
                            novedad.fecha_novedad
                              ? novedad.fecha_novedad.split(" ")[0]
                              : "N/A"
                          }}
                        </td>
                        <td>
                          <i class="fas fa-clock text-warning me-2"></i>
                          {{
                            novedad.fecha_novedad
                              ? novedad.fecha_novedad.split(" ")[1]
                              : "N/A"
                          }}
                        </td>
                        <td>
                          <span class="badge bg-warning">
                            <i class="fas fa-exclamation-triangle me-1"></i>
                            Pendiente
                          </span>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          formulario.estado && formulario.estado !== 'Pendiente'
                        "
                      >
                        <td>
                          <span class="badge bg-success">
                            <i class="fas fa-edit me-1"></i>Actualización
                          </span>
                        </td>
                        <td>
                          <i class="fas fa-building text-info me-2"></i>
                          {{ getEmpresa(novedad) || "N/A" }}
                        </td>
                        <td>
                          <i class="fas fa-truck text-warning me-2"></i>
                          {{ getPlacaVehiculo(novedad) || "N/A" }}
                        </td>
                        <td>
                          <i class="fas fa-user-circle text-primary me-2"></i>
                          {{ getConductor(novedad) || "N/A" }}
                        </td>
                        <td>
                          <i class="fas fa-exclamation-triangle text-warning me-2"></i>
                          {{ getSubnovedad(novedad) || "N/A" }}
                        </td>
                        <td>
                          <i class="fas fa-calendar text-success me-2"></i>
                          {{ new Date().toLocaleDateString() }}
                        </td>
                        <td>
                          <i class="fas fa-clock text-warning me-2"></i>
                          {{ new Date().toLocaleTimeString() }}
                        </td>
                        <td>
                          <span class="badge bg-info">
                            <i class="fas fa-flag me-1"></i>
                            {{ formulario.estado }}
                          </span>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          !formulario.estado ||
                            formulario.estado === 'Pendiente'
                        "
                      >
                        <td colspan="8" class="text-center text-muted py-4">
                          <i class="fas fa-info-circle me-2"></i>
                          No hay gestiones registradas aún
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "GestionNovedadesModal",
  props: {
    novedad: {
      type: Object,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formulario: {
        conductor: "",
        empresa: "",
        celular: "",
        cedula: "",
        direccion: "",
        fecha_reporte: "",
        hora_reporte: "",
        latitud: "",
        longitud: "",
        novedad: "",
        estado: "",
        novedad_reporte: "",
        observaciones: "",
      },
      errores: {},
      guardando: false,
      tiposNovedad: [],
      estados: [],
      novedadesEnRuta: [],
      mapCenter: { lat: 7.067455, lng: -73.645138 },
      mapZoom: 12,
      markerPosition: { lat: 7.067455, lng: -73.645138 },
      markerIcon: {
        url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
        scaledSize: { width: 32, height: 32 },
      },
      tabActiva: "crear",
      mapTabActiva: "mapa",
    };
  },
  computed: {
    puedeGuardar() {
      return this.formulario.direccion.trim() && 
             this.formulario.fecha_reporte && 
             this.formulario.hora_reporte && 
             this.formulario.novedad_reporte;
      // El estado se establece automáticamente como Gestionado (ID 2)
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.inicializarModal();
        this.$nextTick(() => {
          this.mostrarModal();
        });
      }
    },
    novedad: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          // Esperar a que las listas estén cargadas
          this.$nextTick(() => {
            this.cargarDatosNovedad();
          });
        }
      },
      deep: true,
    },
    tiposNovedad: {
      handler() {
        if (this.novedad && Object.keys(this.novedad).length > 0) {
          this.cargarDatosNovedad();
        }
      },
    },
    estados: {
      handler() {
        if (this.novedad && Object.keys(this.novedad).length > 0) {
          this.cargarDatosNovedad();
        }
      },
    },
    tabActiva: {
      handler(newVal) {
        // El mapa se oculta automáticamente con v-show
        console.log("Tab activa:", newVal);
      },
    },
  },
  methods: {
    inicializarModal() {
      this.cargarListas();
      this.cargarDatosNovedad();
      this.errores = {};
    },

    async cargarListas() {
      try {
        // Cargar tipos de novedad usando la ruta correcta del backend
        const tiposResponse = await axios.get(
          "/api/admin/centralTrafico/listaTiposNovedad"
        );
        this.tiposNovedad = tiposResponse.data;

        // Cargar estados de gestión usando la ruta correcta del backend
        const estadosResponse = await axios.get(
          "/api/admin/centralTrafico/listaEstadosGestion"
        );
        this.estados = estadosResponse.data;

        // Cargar novedades en ruta (lista 223)
        const novedadesEnRutaResponse = await axios.get(
          "/api/admin/centralTrafico/listaNovedadesEnRuta"
        );
        this.novedadesEnRuta = novedadesEnRutaResponse.data;
        console.log('Novedades en ruta cargadas:', this.novedadesEnRuta);
      } catch (error) {
        console.error("Error al cargar listas:", error);
        // Usar datos por defecto si falla la carga
        this.tiposNovedad = [
          { id: 1, nombre: "GPS" },
          { id: 2, nombre: "Rutas" },
          { id: 3, nombre: "Parada no programada" },
          { id: 4, nombre: "Ruta diferente" },
        ];
        this.estados = [
          { id: 1, nombre: "Pendiente" },
          { id: 2, nombre: "En proceso" },
          { id: 3, nombre: "Resuelto" },
          { id: 4, nombre: "Cancelado" },
        ];
        this.novedadesEnRuta = [
          { id: 1, nombre: "Accidente" },
          { id: 2, nombre: "Avería" },
          { id: 3, nombre: "Retraso" },
          { id: 4, nombre: "Desvío" },
          { id: 5, nombre: "Emergencia" },
        ];
        console.log('Usando datos por defecto para novedades en ruta:', this.novedadesEnRuta);

        this.$swal({
          icon: "warning",
          title: "Advertencia",
          text: "No se pudieron cargar las listas, usando datos por defecto",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    cargarDatosNovedad() {
      if (this.novedad && Object.keys(this.novedad).length > 0) {
        // Buscar el nombre del tipo de novedad
        let nombreNovedad = "";
        if (this.novedad.tipo_novedad) {
          const tipoNovedad = this.tiposNovedad.find(
            (tipo) => tipo.id == this.novedad.tipo_novedad
          );
          nombreNovedad = tipoNovedad
            ? tipoNovedad.nombre
            : this.novedad.tipo_novedad;
        }

        // Buscar el nombre del estado
        let nombreEstado = "";
        if (this.novedad.estado) {
          const estado = this.estados.find(
            (est) => est.id == this.novedad.estado
          );
          nombreEstado = estado ? estado.nombre : this.novedad.estado;
        }

        console.log("Datos de la novedad:", this.novedad);
        console.log("Tipos de novedad disponibles:", this.tiposNovedad);
        console.log("Estados disponibles:", this.estados);
        console.log("Nombre de novedad encontrado:", nombreNovedad);
        console.log("Nombre de estado encontrado:", nombreEstado);

          // Obtener fecha y hora actual
          const ahora = new Date();
          const fechaActual = ahora.toISOString().split('T')[0]; // YYYY-MM-DD
          const horaActual = ahora.toTimeString().split(' ')[0].substring(0, 5); // HH:MM

          // Obtener datos del conductor
          let conductorNombre = "";
          let conductorCelular = "";
          let conductorCedula = "";
          
          if (this.novedad.conductor) {
            conductorNombre = `${this.novedad.conductor.nombres || ''} ${this.novedad.conductor.apellidos || ''}`.trim();
            conductorCelular = this.novedad.conductor.celular_principal || this.novedad.conductor.celular || "Sin asignar";
            conductorCedula = this.novedad.conductor.numero_documento || this.novedad.conductor.documento || "";
          }

          // Obtener datos de la empresa (desde viaje o postulación)
          let empresaNombre = "";
          console.log("🏢 Debugging empresa en modal:");
          console.log("  - Viaje transportadora:", this.novedad.viaje?.transportadora);
          console.log("  - DetPostulacion detSolicitudDiaria empresa:", this.novedad.detPostulacion?.detSolicitudDiaria?.empresa);
          console.log("  - Det_postulacion detSolicitudDiaria empresa:", this.novedad.det_postulacion?.detSolicitudDiaria?.empresa);
          
          if (this.novedad.viaje?.transportadora?.razon_social) {
            empresaNombre = this.novedad.viaje.transportadora.razon_social;
            console.log("  - Empresa desde viaje:", empresaNombre);
          } else if (this.novedad.detPostulacion?.det_solicitud_diaria?.empresa?.razon_social) {
            empresaNombre = this.novedad.detPostulacion.det_solicitud_diaria.empresa.razon_social;
            console.log("  - Empresa desde detPostulacion (snake_case):", empresaNombre);
          } else if (this.novedad.detPostulacion?.detSolicitudDiaria?.empresa?.razon_social) {
            empresaNombre = this.novedad.detPostulacion.detSolicitudDiaria.empresa.razon_social;
            console.log("  - Empresa desde detPostulacion (camelCase):", empresaNombre);
          } else if (this.novedad.det_postulacion?.det_solicitud_diaria?.empresa?.razon_social) {
            empresaNombre = this.novedad.det_postulacion.det_solicitud_diaria.empresa.razon_social;
            console.log("  - Empresa desde det_postulacion (snake_case):", empresaNombre);
          } else if (this.novedad.det_postulacion?.detSolicitudDiaria?.empresa?.razon_social) {
            empresaNombre = this.novedad.det_postulacion.detSolicitudDiaria.empresa.razon_social;
            console.log("  - Empresa desde det_postulacion (camelCase):", empresaNombre);
          } else if (this.novedad.empresa) {
            empresaNombre = this.novedad.empresa;
            console.log("  - Empresa directa:", empresaNombre);
          }
          
          console.log("  - Empresa final:", empresaNombre);

          this.formulario = {
            conductor: conductorNombre,
            empresa: empresaNombre,
            celular: conductorCelular,
            cedula: conductorCedula,
            direccion: this.novedad.direccion || "",
            fecha_reporte: fechaActual, // Fecha actual por defecto
            hora_reporte: horaActual, // Hora actual por defecto
            latitud: this.novedad.latitud || "",
            longitud: this.novedad.longitud || "",
            novedad: nombreNovedad,
            estado: nombreEstado,
            observaciones: this.novedad.observaciones || "",
          };

        // Actualizar mapa
        if (this.novedad.latitud && this.novedad.longitud) {
          this.mapCenter = {
            lat: parseFloat(this.novedad.latitud),
            lng: parseFloat(this.novedad.longitud),
          };
          this.markerPosition = {
            lat: parseFloat(this.novedad.latitud),
            lng: parseFloat(this.novedad.longitud),
          };
        }
      }
    },

    buscarConductor() {
      // Implementar búsqueda de conductores
      this.$swal({
        title: "Buscar Conductor",
        text: "Funcionalidad de búsqueda de conductores en desarrollo",
        icon: "info",
      });
    },

    limpiarConductor() {
      this.formulario.conductor = "";
    },

    confirmarConductor() {
      if (this.formulario.conductor) {
        this.$swal({
          icon: "success",
          title: "Conductor confirmado",
          text: "El conductor ha sido seleccionado correctamente",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    },

    onMapClick(event) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      this.formulario.latitud = lat.toFixed(6);
      this.formulario.longitud = lng.toFixed(6);
      this.markerPosition = { lat, lng };
    },

    onMarkerClick() {
      this.$swal({
        title: "Ubicación seleccionada",
        text: `Lat: ${this.formulario.latitud}, Lng: ${this.formulario.longitud}`,
        icon: "info",
      });
    },

    validarFormulario() {
      this.errores = {};

      if (!this.formulario.direccion.trim()) {
        this.errores.direccion = "La dirección es requerida";
      }

      if (!this.formulario.fecha_reporte) {
        this.errores.fecha_reporte = "La fecha de reporte es requerida";
      }

      if (!this.formulario.hora_reporte) {
        this.errores.hora_reporte = "La hora de reporte es requerida";
      }

      if (!this.formulario.novedad_reporte) {
        this.errores.novedad_reporte = "La novedad en ruta es requerida";
      }

      // El estado se establece automáticamente como Gestionado (ID 2)
      // No se requiere validación del campo estado

      return Object.keys(this.errores).length === 0;
    },

    async guardarNovedad() {
      if (!this.validarFormulario()) {
        this.$swal({
          icon: "error",
          title: "Error de validación",
          text: "Por favor corrija los errores en el formulario",
        });
        return;
      }

      this.guardando = true;

        try {
          // Buscar el ID de la novedad en ruta seleccionada
          const novedadEnRutaSeleccionada = this.novedadesEnRuta.find(
            (novedad) => novedad.nombre === this.formulario.novedad_reporte
          );
          const novedadEnRutaId = novedadEnRutaSeleccionada
            ? novedadEnRutaSeleccionada.id
            : this.formulario.novedad_reporte;

          const datos = {
            direccion: this.formulario.direccion,
            fecha_reporte: this.formulario.fecha_reporte,
            hora_reporte: this.formulario.hora_reporte,
            novedad_en_ruta: novedadEnRutaId, // Enviar el ID de la novedad en ruta
            estado: 2, // Siempre establecer como Gestionado (ID 2)
            observaciones: this.formulario.observaciones,
            novedad_id: this.novedad.id,
          };

          console.log('Datos a enviar:', datos);

        await axios.post("/api/admin/centralTrafico/gestionarNovedad", datos);

        this.$swal({
          icon: "success",
          title: "Novedad guardada",
          text: "La novedad ha sido guardada correctamente",
          timer: 2000,
          showConfirmButton: false,
        });

        this.$emit("novedad-guardada");
        this.cerrarModal();
      } catch (error) {
        console.error("Error al guardar novedad:", error);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "No se pudo guardar la novedad",
        });
      } finally {
        this.guardando = false;
      }
    },

    limpiarFormulario() {
      this.formulario = {
        conductor: "",
        empresa: "",
        celular: "",
        cedula: "",
        direccion: "",
        fecha_reporte: "",
        hora_reporte: "",
        latitud: "",
        longitud: "",
        novedad: "",
        estado: "",
        observaciones: "",
      };
      this.errores = {};
    },

    limpiarErrores() {
      this.errores = {};
    },

    // Métodos para obtener información de la novedad
    getPlacaVehiculo(novedad) {
      if (!novedad) return null;
      
      // Si viene por viaje
      if (novedad.viaje?.vehiculo?.placa) {
        return novedad.viaje.vehiculo.placa;
      }
      
      // Si viene por postulación
      if (novedad.vehiculo?.placa) {
        return novedad.vehiculo.placa;
      }
      if (novedad.detPostulacion?.vehiculo?.placa) {
        return novedad.detPostulacion.vehiculo.placa;
      }
      if (novedad.det_postulacion?.vehiculo?.placa) {
        return novedad.det_postulacion.vehiculo.placa;
      }
      
      return null;
    },

    getRemolque(novedad) {
      if (!novedad) return null;
      
      // Si viene por viaje
      if (novedad.viaje?.remolque?.placa) {
        return novedad.viaje.remolque.placa;
      }
      
      // Si viene por postulación
      if (novedad.remolque?.placa) {
        return novedad.remolque.placa;
      }
      if (novedad.detPostulacion?.remolque?.placa) {
        return novedad.detPostulacion.remolque.placa;
      }
      if (novedad.det_postulacion?.remolque?.placa) {
        return novedad.det_postulacion.remolque.placa;
      }
      
      return null;
    },

    getConductor(novedad) {
      if (!novedad) return null;
      
      let conductor = null;
      
      // Si viene por viaje
      if (novedad.viaje?.conductor) {
        conductor = novedad.viaje.conductor;
      } else if (novedad.conductor) {
        conductor = novedad.conductor;
      } else if (novedad.detPostulacion?.conductor) {
        conductor = novedad.detPostulacion.conductor;
      } else if (novedad.det_postulacion?.conductor) {
        conductor = novedad.det_postulacion.conductor;
      }
      
      if (conductor) {
        const nombres = conductor.nombres || '';
        const apellidos = conductor.apellidos || '';
        return `${nombres} ${apellidos}`.trim() || null;
      }
      
      return null;
    },

    getConductorCelular(novedad) {
      if (!novedad) return null;
      
      // Si viene por viaje
      if (novedad.viaje?.conductor?.celular_principal) {
        return novedad.viaje.conductor.celular_principal;
      }
      
      // Si viene por postulación
      if (novedad.conductor?.celular_principal) {
        return novedad.conductor.celular_principal;
      }
      if (novedad.detPostulacion?.conductor?.celular_principal) {
        return novedad.detPostulacion.conductor.celular_principal;
      }
      if (novedad.det_postulacion?.conductor?.celular_principal) {
        return novedad.det_postulacion.conductor.celular_principal;
      }
      
      return null;
    },

    getConductorDocumento(novedad) {
      if (!novedad) return null;
      
      // Si viene por viaje
      if (novedad.viaje?.conductor?.numero_documento) {
        return novedad.viaje.conductor.numero_documento;
      }
      
      // Si viene por postulación
      if (novedad.conductor?.numero_documento) {
        return novedad.conductor.numero_documento;
      }
      if (novedad.detPostulacion?.conductor?.numero_documento) {
        return novedad.detPostulacion.conductor.numero_documento;
      }
      if (novedad.det_postulacion?.conductor?.numero_documento) {
        return novedad.det_postulacion.conductor.numero_documento;
      }
      
      return null;
    },

    getEmpresa(novedad) {
      if (!novedad) return null;
      
      // Preferencias por viaje
      if (novedad.viaje?.transportadora?.razon_social) {
        return novedad.viaje.transportadora.razon_social;
      }

      // Preferencias por postulación (snake_case primero, luego camelCase)
      if (novedad.detPostulacion?.det_solicitud_diaria?.empresa?.razon_social) {
        return novedad.detPostulacion.det_solicitud_diaria.empresa.razon_social;
      }
      if (novedad.detPostulacion?.detSolicitudDiaria?.empresa?.razon_social) {
        return novedad.detPostulacion.detSolicitudDiaria.empresa.razon_social;
      }
      if (novedad.det_postulacion?.det_solicitud_diaria?.empresa?.razon_social) {
        return novedad.det_postulacion.det_solicitud_diaria.empresa.razon_social;
      }
      if (novedad.det_postulacion?.detSolicitudDiaria?.empresa?.razon_social) {
        return novedad.det_postulacion.detSolicitudDiaria.empresa.razon_social;
      }

      // Campos directos en caso de addSelect en backend
      if (novedad.nEmpresa) {
        return novedad.nEmpresa;
      }
      if (novedad.empresa) {
        return typeof novedad.empresa === 'string' ? novedad.empresa : (novedad.empresa.nombre || novedad.empresa.razon_social || null);
      }
      
      return null;
    },

    getSubnovedad(novedad) {
      if (!novedad) return null;
      if (novedad.nSubNovedadGps || novedad.nSubNovedadRuta) {
        return novedad.nSubNovedadGps || novedad.nSubNovedadRuta;
      }
      if (novedad.nSubNovedad) {
        return novedad.nSubNovedad;
      }
      if (novedad.tipo_subnovedad) {
        return String(novedad.tipo_subnovedad);
      }
      return null;
    },

    establecerFechaActual() {
      const ahora = new Date();
      this.formulario.fecha_reporte = ahora.toISOString().split('T')[0];
      this.limpiarErrores();
    },

    establecerHoraActual() {
      const ahora = new Date();
      this.formulario.hora_reporte = ahora.toTimeString().split(' ')[0].substring(0, 5);
      this.limpiarErrores();
    },

    establecerFechaHoraActual() {
      const ahora = new Date();
      this.formulario.fecha_reporte = ahora.toISOString().split('T')[0];
      this.formulario.hora_reporte = ahora.toTimeString().split(' ')[0].substring(0, 5);
      this.limpiarErrores();
      
      this.$swal({
        icon: 'success',
        title: 'Fecha y hora actualizadas',
        text: 'Se ha establecido la fecha y hora actual',
        timer: 2000,
        showConfirmButton: false
      });
    },

    mostrarModal() {
      // El modal se muestra automáticamente con v-if="visible"
      // Solo necesitamos prevenir el scroll del body
      document.body.classList.add("modal-open");
    },

    cerrarModal() {
      // Cerrar el modal emitiendo el evento
      document.body.classList.remove("modal-open");
      this.$emit("cerrar");
    },

    getTipoSubNovedad(novedad) {
      if (!novedad) return "";

      // Buscar el tipo de subnovedad según el tipo de novedad
      const tipoNovedad = novedad.tipo_novedad;

      if (tipoNovedad === 1) {
        // GPS
        return novedad.nSubNovedadGps || "GPS";
      } else if (tipoNovedad === 2) {
        // Rutas
        return novedad.nSubNovedadRutas || "Rutas";
      } else if (tipoNovedad === 3) {
        // Parada no programada
        return novedad.nSubNovedadParada || "Parada no programada";
      } else if (tipoNovedad === 4) {
        // Ruta diferente
        return novedad.nSubNovedadRutaDiferente || "Ruta diferente";
      }

      return novedad.tipo_subnovedad || "N/A";
    },
  },
};
</script>

<style scoped>
/* Gradiente para el header */
.bg-gradient-primary {
  background: linear-gradient(135deg, #3f0e0e 0%, #474747 100%) !important;
}

/* Estilos para el modal */
.modal {
  z-index: 1050 !important;
  pointer-events: auto !important;
}

.modal-dialog {
  pointer-events: auto !important;
  z-index: 1051 !important;
}

.modal-content {
  pointer-events: auto !important;
  z-index: 1052 !important;
}

.modal-xl {
  max-width: 95%;
}

.card {
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  pointer-events: auto !important;
}

/* Asegurar que todos los elementos sean interactivos */
.modal * {
  pointer-events: auto !important;
}

/* Botones específicos */
.btn {
  pointer-events: auto !important;
  cursor: pointer !important;
}

/* Inputs y selects */
.form-control,
.form-select,
.form-check-input {
  pointer-events: auto !important;
  cursor: pointer !important;
}

/* Tabs */
.nav-link {
  pointer-events: auto !important;
  cursor: pointer !important;
}

/* Botón de cerrar */
.cerrar-btn {
  width: 40px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  font-size: 1.1rem !important;
  transition: all 0.3s ease !important;
  z-index: 10 !important;
  position: absolute !important;
  right: 15px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.cerrar-btn:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: scale(1.1) !important;
  color: white !important;
}

.cerrar-btn:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25) !important;
  color: white !important;
}

/* Estilos para las coordenadas */
.coordenadas-container {
  background-color: rgba(255, 255, 255, 0.15) !important;
  border-radius: 12px !important;
  padding: 8px 16px !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  margin-right: 60px !important; /* Espacio para el botón de cerrar */
}

.coordenada-item {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  text-align: center !important;
  min-width: 80px !important;
}

.coordenada-label {
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  margin-bottom: 2px !important;
  display: flex !important;
  align-items: center !important;
}

.coordenada-valor {
  font-size: 0.9rem !important;
  font-weight: 700 !important;
  color: white !important;
  font-family: "Courier New", monospace !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
  min-width: 60px !important;
  text-align: center !important;
}

.coordenada-separador {
  font-size: 1.2rem !important;
  font-weight: 300 !important;
  color: rgba(255, 255, 255, 0.6) !important;
  margin: 0 12px !important;
  align-self: center !important;
}

/* Estilos para campos deshabilitados */
.form-control:disabled {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  cursor: not-allowed !important;
  opacity: 0.7 !important;
  border-color: #dee2e6 !important;
}

.btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

/* Tabs personalizados */
.nav-tabs {
  border-bottom: 2px solid #e9ecef;
}

.nav-tabs .nav-link {
  border: none;
  color: #6c757d;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 0;
  transition: all 0.3s ease;
}

.nav-tabs .nav-link:hover {
  border-color: transparent;
  color: #495057;
  background-color: #f8f9fa;
}

.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-bottom: 3px solid #007bff;
  font-weight: 600;
}

/* Formulario */
.form-label {
  color: #495057;
  margin-bottom: 0.5rem;
}

.form-control,
.form-select {
  border-radius: 8px;
  border: 1px solid #ced4da;
  transition: all 0.3s ease;
}

.form-control:focus,
.form-select:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.input-group-text {
  border-radius: 0 8px 8px 0;
}

/* Cards de información */
.info-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.5rem;
  border-left: 4px solid #007bff;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.info-item i {
  width: 20px;
  text-align: center;
  font-size: 1.1rem;
}

.info-item .label {
  font-weight: 600;
  color: #495057;
  min-width: 100px;
}

.info-item .value {
  color: #6c757d;
  flex: 1;
}

/* Mapa */
.mapa-container {
  position: relative;
  background: #f8f9fa;
}

.mapa-tabs {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.mapa-tabs .nav-tabs {
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 0;
}

.mapa-tabs .nav-link {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
}

.mapa-content {
  height: 100%;
  padding-top: 50px; /* Espacio para los tabs */
}

/* Botones */
.btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

/* Responsive */
@media (max-width: 991.98px) {
  .modal-xl {
    max-width: 100%;
  }

  .mapa-container {
    height: 400px;
  }

  .mapa-content {
    padding-top: 40px;
  }
}

/* Animaciones */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tab-pane {
  animation: fadeIn 0.3s ease-out;
}

/* Estados de validación */
.is-invalid {
  border-color: #dc3545 !important;
}

.invalid-feedback {
  display: block;
  font-size: 0.875rem;
  color: #dc3545;
  margin-top: 0.25rem;
}
</style>
